export const EVENT_TYPE_UI_ERROR = 'UI_Error';
export const EVENT_TYPE_BAD_REQUEST_ERROR = 'UI_BAD_REQUEST_Error';

export const ERROR_TYPE_VALIDATION = 'validation';

export const LOG_LEVEL_INFO = 'info';
export const LOG_LEVEL_WARNING = 'warning';
export const LOG_LEVEL_ERROR = 'error';

// frontend-service relies on this exact value to pick the log level of failed HTTP request reports
export const LOG_SOURCE_FE_REQUEST_FAILED = 'FE_REQUEST_FAILED';
export const LOG_SOURCE_FE = 'FE_LOG';
export const REQUEST_FAILED_LOG_TEMPLATE = 'Request failed (Method: %s, URL: %s, Status: %s)';
